module.exports = __webpack_public_path__ + "img/cofide.a6defaf6.svg";